export enum AccountConfigurationType {
    ConfigurationProjectVisibility = 0
}